import React, { useContext, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import Chip from '@mui/material/Chip';
import { Button } from '@mui/material';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import EditNoteIcon from '@mui/icons-material/EditNote';
import RestoreIcon from '@mui/icons-material/Restore';
import DeleteIcon from '@mui/icons-material/Delete';
import useWwwContext from '../context/useWwwContext';

function Table() {
  const {
    activeTab,
    loading,
    wwwData,
    addAgendaModal,
    setAddAgendaModal,
    handleUpdate,
    hanldeArchied,
    handleRestore,
  } = useContext(useWwwContext);

  const actionButton =
    activeTab === 0
      ? [
          {
            field: 'action',
            headerName: 'Action',
            width: 300,
            renderCell: ({ row }) => (
              <div>
                <Button
                  size='small'
                  variant='contained'
                  color='success'
                  onClick={() => handleUpdate(row.id)}
                  startIcon={<EditNoteIcon />}
                >
                  Update
                </Button>
                &nbsp;
                <Button
                  size='small'
                  variant='contained'
                  color='error'
                  onClick={() => hanldeArchied(row.id)}
                  startIcon={<DeleteIcon />}
                >
                  Archived
                </Button>
              </div>
            ),
          },
        ]
      : [
          {
            field: 'action',
            headerName: 'Action',
            width: 300,
            renderCell: ({ row }) => (
              <div>
                <Button
                  size='small'
                  variant='contained'
                  color='primary'
                  onClick={() => handleRestore(row.id)}
                  startIcon={<RestoreIcon />}
                >
                  Restore
                </Button>
              </div>
            ),
          },
        ];
  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const columns = [
    {
      field: 'description',
      headerName: 'Description',
      width: 200,
      flex: 1,
    },
    {
      field: 'with_text_input',
      headerName: 'With Text Input',
      width: 200,
      flex: 1,
      renderCell: ({ row }) => (
        <Chip
          label={row.with_text_input}
          color={row.with_text_input === 'YES' ? 'success' : 'default'}
        />
      ),
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 200,
      flex: 1,
      renderCell: ({ row }) => (
        <Chip label={row.status} color={row.status === 'Published' ? 'success' : 'default'} />
      ),
    },
    ...actionButton,
  ];

  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} md={12}>
        <Button
          size='small'
          variant='contained'
          color='success'
          sx={{ float: 'right' }}
          onClick={() => setAddAgendaModal({ ...addAgendaModal, toggle: true })}
          startIcon={<AddOutlinedIcon />}
        >
          Add New What Went Well
        </Button>
      </Grid>
      <Grid xs={12} sm={12} md={12}>
        <div
          className='table-container'
          style={{
            height: '800px',
            marginLeft: '20px',
            '& .MuiChip-root': {
              borderRadius: 0,
            },
          }}
        >
          <DataGridPro
            loading={loading}
            rows={wwwData}
            columns={columns}
            sortModel={sortModel}
            initialState={{
              ...wwwData.initialState,
              pagination: { paginationModel: { pageSize: 50 } },
            }}
            pageSizeOptions={[25, 50, 75, 100]}
            pagination
            onSortModelChange={(model) => setSortModel(model)}
          />
        </div>
      </Grid>
    </Grid>
  );
}

export default Table;
